import { Permission } from "store/permissions/types";

export type Role = {
  id: number;
  name: string;
  label: string;
  secrecy: number;
  secrecy_label: string;
  permissions: Permission[];
  type: RoleTypes;
  protected: boolean;
  deletable: boolean;
  description: string | null;
};

export type UpdateRole = {
  label: string;
  secrecy?: number;
  permissions: string[];
  type?: RoleTypes;
  description?: string;
};

export enum MeetingRoles {
  meetingAdmin = "meeting_admin",
  meetingOrganizer = "meeting_organizer",
  meetingShareholder = "meeting_shareholder",
  meetingBoardOfDirectors = "meeting_board_of_directors",
  meetingExecutiveManagement = "meeting_executive_management",
  meetingIndependentBoardMember = "meeting_independent_board_member",
  meetingExecutiveBrdMbrCom = "meeting_executive_brd_mbr_com",
  meetingAuditor = "meeting_auditor",
  meetingRegularGeneralAssembly = "meeting_regular_general_assembly",
  meetingExtraordinaryGeneralAssembly = "meeting_extraordinary_general_assembly",
  meetingGuest = "meeting_guest",
  meetingViewer = "meeting_viewer",
  meetingOwner = "meeting_owner",
}

export type RolesFilters = Record<string, string>;

export enum RoleTypes {
  GLOBAL = "global",
  MEETING = "meeting",
  VOTING = "voting",
}
